import { Button, Heading, Icon, Input, Select, Stack, Text, Textarea } from "@chakra-ui/react";
import { FaCheck, FaUsers } from "react-icons/fa";



export default function PracticeProfile() {
    
    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'row' }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 0 }}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={FaUsers}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Practice Profile</Heading>
                            <Text fontSize={'sm'}>Manage access and user roles of full team members of your practice.</Text>
                        </Stack>
                    </Stack>
                </Stack>
                <Stack align={{ lg: 'flex-start', xl: 'flex-end' }} justify={'end'} spacing={4}>
                    <Stack direction={'row'}>
                        <Button
                            size={'sm'}
                            leftIcon={<FaCheck />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                        >
                            Edit Fields
                        </Button>
                    </Stack>
                </Stack>
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
                <Stack
                    direction={'row'}
                    w={'full'}
                    justify={'space-between'}
                    spacing={4}
                >
                    <Select placeholder='Organization Type' w={'100%'}>
                        <option value='option1'>Non Profit Organization</option>
                        <option value='option2'>Limited Company</option>
                    </Select>

                    <Input type='text' size={'md'} w={'100%'} fontSize={'md'} placeholder='Display Name' />

                    <Input type='text' size={'md'} w={'100%'} fontSize={'md'} placeholder='Legal Name' />
                </Stack>

                <Stack
                    direction={'row'}
                    w={'full'}
                    justify={'space-between'}
                    spacing={4}
                >
                    <Input type='text' size={'md'} w={'100%'} fontSize={'md'} placeholder='Email Address' />

                    <Input type='text' size={'md'} w={'100%'} fontSize={'md'} placeholder='Website' />

                    <Input type='text' size={'md'} w={'100%'} fontSize={'md'} placeholder='Telephone Number' />
                </Stack>

                <Stack
                    direction={'row'}
                    w={'full'}
                    justify={'space-between'}
                    spacing={4}
                >
                    <Select placeholder='Country' w={'100%'}>
                        <option value='option1'>UK</option>
                        <option value='option2'>USA</option>
                        <option value='option2'>IRE</option>
                        <option value='option2'>PK</option>
                        <option value='option2'>IN</option>
                        <option value='option2'>THL</option>
                        <option value='option2'>AUS</option>
                        <option value='option2'>AUS</option>
                        <option value='option2'>UAE</option>
                        <option value='option2'>SA</option>
                        <option value='option2'>SL</option>
                    </Select>

                    <Select placeholder='City/State' w={'100%'}>
                        <option value='option1'>Karachi / Sindh</option>
                        <option value='option2'>Sukkur / Sindh</option>
                        <option value='option2'>Jamshoro / Sindh</option>
                        <option value='option2'>Multan / Punjab</option>
                        <option value='option2'>Lahore / Punjab</option>
                        <option value='option2'>Islamabad / Punjab</option>
                        <option value='option2'>Peshawar / KPK</option>
                    </Select>

                    <Input type='number' size={'md'} w={'100%'} fontSize={'md'} placeholder='Postal Code' />
                </Stack>

                <Stack
                    direction={'row'}
                    w={'full'}
                    justify={'space-between'}
                    spacing={4}
                >
                    <Textarea
                        w={'100%'}
                        h={'100px'}
                        resize={'none'}
                        placeholder={"Address Line 1"}
                    >
                    </Textarea>
                    <Textarea
                        w={'100%'}
                        h={'100px'}
                        resize={'none'}
                        placeholder={"Address Line 2"}
                    >
                    </Textarea>
                </Stack>

                <Stack
                    direction={'row'}
                    w={'full'}
                    justify={'space-between'}
                    spacing={4}
                >
                    <Input type='text' size={'md'} w={'100%'} fontSize={'md'} placeholder='Website' />

                    <Input type='text' size={'md'} w={'100%'} fontSize={'md'} placeholder='Tax Register Number' />

                    <Input type='text' size={'md'} w={'100%'} fontSize={'md'} placeholder='Company Reference' />
                </Stack>
                <Button colorScheme={'primary'}>Save</Button>
            </Stack>
        </Stack >
    )
}